export const OrderErrorsEndpoints = {
  GET_ORDER_ERRORS: (orderNumber: string) => `/api/admin/orders/${orderNumber}/errors`,
  SEARCH_ORDER_ERRORS: '/api/admin/order-errors',
};
